// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2d1300bc] .modal-dialog .modal-content {\n  border: none;\n}\n[data-v-2d1300bc] .modal-dialog .custom-control-input[disabled] ~ .custom-control-label {\n  cursor: not-allowed;\n}\n[data-v-2d1300bc] .modal-dialog button:disabled {\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
